export default "__VITE_PUBLIC_ASSET__851a889f__"